<template>
	<article>
		<div class="p-5">
			<h1>Sökresultat för "{{ activeSearchString }}"</h1>
			<span v-if="autoCorrectQuery">Hittade inga resultat för {{ searchString }}</span>
			<a-link
				v-if="searchPhraseLink"
				class="search-banner"
				:to="searchPhraseLink"
				@click.native="click"
			>
				<ximg
					:src="convertToCdnUrl(bannerImgSrc)"
					:ariaLabel="searchPhraseData.imageAlt"
					role="img"
					:viewportMargin="1"
					@inViewport="trackImpression"
				/>
			</a-link>
		</div>
		<product-browser
			v-if="trimmedSearchString.length"
			ref="browser"
			:isSearch="true"
			:url="'search/' + trimmedSearchString"
			:alwaysResetResultCount="true"
			:onSearchPage="true"
			:resetData="resetData"
			:autoCorrectQuery.sync="autoCorrectQuery"
		/>
	</article>
</template>

<script>
import Vue from 'vue';
import store from 'datastore';
import metaHandler from 'metaHandler';
import { convertToCdnUrl, standardRoute } from 'utils';
import { trackPromotionImpression } from 'gtm';
import mq from 'mediaQuery';

export default {
	data () {
		return {
			searchString: '',
			hardReset: true,
			resetData: [],
			autoCorrectQuery: null,
			searchPhraseData: {},
			searchPhraseLink: {},
			analyticsData: {},
		};
	},
	willSendScrollTriggerEvent: true,
	mounted () {
		store.commit('productTips/setShowTopLists', false);
		store.commit('productTips/setShowLists', false);
		this.searchString = this.$route.query.searchString || this.$route.params.searchString /*deprecated*/ || '';
		metaHandler.set('robots', 'noindex, follow');
	},
	layoutOptions: {
		leftCol: true,
	},
	computed: {
		trimmedSearchString () {
			return this.searchString ? this.searchString.trim() : '';
		},
		activeSearchString () {
			return this.autoCorrectQuery ?? this.searchString;
		},
		bannerImgSrc () {
			let imgLink = null;
			if (this.searchPhraseData) {
				imgLink = mq.current > mq.sm ? this.searchPhraseData.imageSourceDesktop : this.searchPhraseData.imageSourceMobile;
			}
			return imgLink;
		},
	},
	methods: {
		convertToCdnUrl,
		reset () {
			this.searchString = this.$route.query.searchString;
			this.hardReset = true;
			this.updateQuery();
		},
		updateQuery () {
			if (this.searchString.trim().length > 0) {
				this.resetData = [[{
					type: 'search',
					value: this.searchString.toLowerCase(),
				}], true, this.hardReset, this.hardReset];
			} else {
				this.resetData = [[], true];
			}
			this.hardReset = false;
			Vue.nextTick(() => {
				this.$refs.browser.resetDisableAutoScroll();
			});
		},
		getSearchPhraseData () {
			waja.get('search-phrase/display')
			.data({
				'searchString': this.trimmedSearchString,
			})
			.on('success', res => {
				this.searchPhraseData = res.data;
				if (this.searchPhraseData?.translatedLinkPageType) {
					this.searchPhraseLink = standardRoute(this.searchPhraseData.translatedLinkPageType, {
						id: this.searchPhraseData.linkId, name: this.searchPhraseData.linkName
					});

					this.analyticsData = {
						location: 'searchpage',
						index: 0,
						position: 0,
						id: this.searchPhraseData.linkId,
						name: this.searchPhraseData.linkName,
						type: this.searchPhraseData.translatedLinkPageType,
					};
				} else {
					this.searchPhraseLink = null;
					this.analyticsData = null;
				}
			}).go();
		},
		click () {
			trackPromotionImpression(this.analyticsData, 'banner', true);
		},
		trackImpression () {
			trackPromotionImpression(this.analyticsData, 'banner');
		}
	},
	watch: {
		trimmedSearchString (text) {
			this.updateQuery();
			this.getSearchPhraseData();
		},
		$route (to) {
			if (to.query.searchString) {
				this.searchString = to.query.searchString;
			}
		},
		// Add autoCorrect to query so it can be read on reload
		autoCorrectQuery (to) {
			if (to) {
				this.$router.setQuery({ ...this.$route.query, autoCorrect: to });
			}
		}
	},
};
</script>
